
const UndoModal = ({ onSave, onUndo }) => {
	return (
		<div>
			<div>
				<p>Do you want to save this shuffle order?</p>
			</div>

			<div className="d-flex gap-1 justify-content-end">
				<button
					className="bg-success text-white border-0"
					style={{ padding: "0.4rem", borderRadius: "0.25rem" }}
					onClick={onSave}>
					Save
				</button>
				<button
					className="bg-danger text-white border-0"
					style={{ padding: "0.4rem", borderRadius: "0.25rem" }}
					onClick={onUndo}>
					Undo
				</button>
			</div>
		</div>
	)
}

export default UndoModal